import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../Home";

const AppRoutes: React.FC<{ msalInstance: any }> = ({ ...props }) => {
  return (
    <Routes>
      <Route
        path="/home"
        element={<Home msalInstance={props.msalInstance} />}
      />
      <Route path="/" element={<Home msalInstance={props.msalInstance} />} />
    </Routes>
  );
};

export default AppRoutes;
